'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var navigator = window.navigator,
    ua = (navigator && navigator.userAgent || '').toLowerCase();

var os = {
    name: '',
    isUnix: /unix/.test(ua),
    isLinux: /linux/.test(ua),
    isIrix: /irix/.test(ua),
    isMac: /mac/.test(ua),
    isSun: /sun/.test(ua),
    isFreeBSD: /freebsd/.test(ua),
    isWindows: /win/.test(ua),
    isWindowsPhone: /windows\s+phone/.test(ua),
    isIOS: /(iphone|ipad)/i.test(ua),
    isAndroid: /android/.test(ua),
    isTouch: /touch|phone/.test(ua)
};

if (os.isUnix) {
    os.name = 'Unix';
} else if (os.isLinux) {
    os.name = 'Linux';
} else if (os.isIrix) {
    os.name = 'Irix';
} else if (os.isMac) {
    os.name = 'MacOS';
} else if (os.isSun) {
    os.name = 'SunOS';
} else if (os.isFreeBSD) {
    os.name = 'FreeBSD';
} else if (os.isWindows) {
    if (/95/.test(ua)) {
        os.name = 'Windows 95';
    } else if (/98/.test(ua)) {
        os.name = 'Windows 98';
    } else if (/2000/.test(ua)) {
        os.name = 'Windows 2000';
    } else if (/windows\s+nt\s+6\.1/.test(ua)) {
        os.name = 'Windows 7';
    } else if (/windows\s+nt\s+6\.2/.test(ua)) {
        os.name = 'Windows 8';
    } else if (/windows\s+nt\s+6\.0/.test(ua)) {
        os.name = 'Windows Vista';
    } else if (/Windows/.test(ua)) {
        os.name = 'Windows XP';
    } else {
        os.name = 'Windows 3.1';
    }
}

var version = (/(?:msie\s([0-9a-z,.]+);)/i.exec(ua) || /trident.*rv:([0-9a-z,.]+)/i.exec(ua) || // msie
/(?:version\/([0-9a-z,.]+))$/.exec(ua) || // opera
/(?:chrome\/([0-9a-z,.]+)\s)/.exec(ua) || // chrome
/(?:firefox\/([0-9a-z,.]+))$/.exec(ua) || // firefox
/(?:version\/([0-9a-z,.]+)\s)/.exec(ua) || // safari
[])[1] || null,
    versionArr = void 0,
    versionAsNumber = 0,
    browser = void 0;

if (version) {
    // (14.0b.1)
    versionArr = version.replace(/[^0-9\.,]/, '').split(/[\.,]/);
    versionAsNumber = +(versionArr.shift() + '.' + versionArr.join('')) || versionAsNumber;
}

browser = {
    version: version,
    versionAsNumber: versionAsNumber,
    isIPhone: /iphone/i.test(ua),
    isIPad: /ipad/i.test(ua),
    isIPod: /ipod/i.test(ua),
    isIPadWebView: /applewebkit/.test(ua) && /mobile/.test(ua),
    isOpera: /'opera'/.test(ua),
    isChrome: /chrome/.test(ua),
    isFireFox: /firefox/.test(ua),
    isIE: /msie|trident/.test(ua)
};

browser.isSafari = !browser.isChrome && /safari/.test(ua);

browser.isMobileDevice = browser.isIPad || browser.isIPod || browser.isIPhone || browser.isIPadWebView || os.isAndroid || os.isIOS || os.isWindowsPhone || os.isTouch;

var language = (navigator && (navigator.systemLanguage || navigator.language.split('-')[0])).toLowerCase() || '';

exports.default = {
    language: language,
    browser: browser,
    os: os
};